<div
  [ngClass]="
    theme() === GrandTotalTheme.RENEWED
      ? 'nordic-blue-900-bg surface-secondary border-bottom border-left border-right rounded-bottom-large pr-small-x pr-xsmall-y'
      : 'mr-xsmall-t white-bg surface-primary border rounded-large pr-small'
  "
  class="grand-total"
>
  <h2
    [ngClass]="
      theme() === GrandTotalTheme.RENEWED ? 'white-text text-icon-primary' : 'nordic-blue-900-text text-icon-primary'
    "
    class="font-heading-5 flex font-title-small"
  >
    <span class="flex-1 flex--basis0">{{ 'price.grandTotal' | finLocalization }}</span>
    <span class="flex-1 flex--basis0 flex flex--wrap flex--end align-right">
      @if (originalTotalPrice(); as originalTotalPrice) {
        <span class="strike-through pr-xxsmall-r">{{ originalTotalPrice | finPrice: { useSymbol: useSymbol() } }}</span>
      }
      @if (totalPoints(); as points) {
        <span data-testid="total-points-and-price">
          <span data-testid="total-points" class="nowrap">
            {{ ('award.points' | finLocalization: { pointsAmount: points || 0 | finPoints }) + '&nbsp;+&nbsp;' }}</span
          >
          {{ totalPrice() | finPrice: { useSymbol: useSymbol() } }}
        </span>
      }
      @if (totalPoints() === null) {
        <span>{{ totalPrice() | finPrice: { useSymbol: useSymbol() } }}</span>
      }
    </span>
  </h2>
</div>
